'use strict';

var AppDispatcher = require('../AppDispatcher'),
    FacebookManager = require('../utils/FacebookManager'),
    InvitationAPI = require('../api/InvitationAPI'),
    ActionTypes = require('../constants/ActionTypes');

var FacebookActionCreators = {
  sendFacebookInvite(invite, resend) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.SEND_FB_INVITE
    });

    FacebookManager.showFacebookSendDialog(invite).then(function() {
      AppDispatcher.handleServerAction({
        type: ActionTypes.SEND_FB_INVITE_SUCCESS
      });

      if (!resend) {
        AppDispatcher.handleViewAction({
          type: ActionTypes.UPDATE_INVITE
        });

        InvitationAPI.updateInvite(invite);
      } else {
        // lazy way to call RESEND_INVITE_SUCCESS for InvitationStore update
        InvitationAPI.resendInvite(invite.id);
      }
    }, function() {
      AppDispatcher.handleServerAction({
        type: ActionTypes.SEND_FB_INVITE_ERROR
      });
    });
  }
};

module.exports = FacebookActionCreators;


/** WEBPACK FOOTER **
 ** ./actions/FacebookActionCreators.js
 **/